import { telefoneMask } from "../../regex/telefoneMask";

const emailValido = (email) => {
	const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
	return regex.test(email);
};

const cpfValido = (cpf: string): boolean => {
	if (!cpf) return false;
	cpf = cpf.replace(/[^\d]+/g, "");
	if (cpf.length !== 11) return false;
	let soma = 0;
	let resto;
	if (cpf === "00000000000") return false;
	for (let i = 1; i <= 9; i++)
		soma += parseInt(cpf.substring(i - 1, i)) * (11 - i);
	resto = (soma * 10) % 11;
	if (resto === 10 || resto === 11) resto = 0;
	if (resto !== parseInt(cpf.substring(9, 10))) return false;
	soma = 0;
	for (let i = 1; i <= 10; i++)
		soma += parseInt(cpf.substring(i - 1, i)) * (12 - i);
	resto = (soma * 10) % 11;
	if (resto === 10 || resto === 11) resto = 0;
	if (resto !== parseInt(cpf.substring(10, 11))) return false;
	return true;
};

const cnpjValido = (cnpj: string): boolean => {
	if (!cnpj) return false;
	cnpj = cnpj.replace(/[^\d]+/g, "");
	if (cnpj.length !== 14) return false;
	if (
		cnpj === "00000000000000" ||
		cnpj === "11111111111111" ||
		cnpj === "22222222222222" ||
		cnpj === "33333333333333" ||
		cnpj === "44444444444444" ||
		cnpj === "55555555555555" ||
		cnpj === "66666666666666" ||
		cnpj === "77777777777777" ||
		cnpj === "88888888888888" ||
		cnpj === "99999999999999"
	)
		return false;
	let tamanho = cnpj.length - 2;
	let numeros = cnpj.substring(0, tamanho);
	let digitos = cnpj.substring(tamanho);
	let soma = 0;
	let pos = tamanho - 7;
	for (let i = tamanho; i >= 1; i--) {
		soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
		if (pos < 2) pos = 9;
	}
	let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
	if (resultado !== parseInt(digitos.charAt(0))) return false;
	tamanho = tamanho + 1;
	numeros = cnpj.substring(0, tamanho);
	soma = 0;
	pos = tamanho - 7;
	for (let i = tamanho; i >= 1; i--) {
		soma += parseInt(numeros.charAt(tamanho - i)) * pos--;
		if (pos < 2) pos = 9;
	}
	resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
	if (resultado !== parseInt(digitos.charAt(1))) return false;
	return true;
};

const documentoValido = (documento: string): boolean => {
	return cpfValido(documento) || cnpjValido(documento);
};

const telefoneValido = (telefone) => {
	const telefoneMascarado = telefoneMask(telefone);
	const regexCelular = /^\(\d{2}\)9\d{4}-\d{4}$/;
	const regexFixo = /^\(\d{2}\)\d{4}-\d{4}$/;
	return (
		regexCelular.test(telefoneMascarado) || regexFixo.test(telefoneMascarado)
	);
};

const verificaPlacaValida = (placa) => {
	const regexMercosul = /^[A-Z]{3}[0-9][A-Z][0-9]{2}$/;
	const regexAntigo = /^[A-Z]{3}[0-9]{4}$/;
	return regexMercosul.test(placa) || regexAntigo.test(placa);
};

const renavamValido = (renavam) => {
	const regexRenavam = /^\d{11}$/;
	return regexRenavam.test(renavam);
};

const cnhValido = (cnh: string): boolean => {
	const regexCnh = /^\d{11}$/;
	return regexCnh.test(cnh);
};

const isValidJson = (str: string): boolean => {
	try {
		JSON.parse(str);
		return true;
	} catch (e) {
		return false;
	}
};

function getFileType(url) {
	if (url.includes(".pdf")) {
		return "pdf";
	} else if (/\.(png|jpe?g|gif|webp)/i.test(url)) {
		return "image";
	} else if (url.startsWith("blob:")) {
		return "blob";
	}
	return "unknown";
}

export {
	cnhValido, cnpjValido, cpfValido, documentoValido, emailValido, getFileType, isValidJson, renavamValido, telefoneValido,
	verificaPlacaValida
};

